<template>
    <div id="appIndex">
        <loadingS v-if='loading'></loadingS>
        <template v-else>
            <div class="appIndex_banner">
                <div class="back_icon"
                     @click="goBack"></div>
            </div>
            <div class="subject_list">
                <!-- 小学语文期末测试一 -->
                <template v-if="yw1.length">
                    <div class="list_title"><span class="title_decoration"><i></i>语文阶段性检测一<i></i></span></div>
                    <div class="unit_list">
                        <div class="list_item"
                             v-for="(item,index) in yw1"
                             :key="index">
                            <div class="unit_name ellipsis">{{item.unit_name}}</div>
                            <router-link class="preview_btn"
                                         :to="'/chinese/inspect/preview/task/'+item.paper_id+'?hd_type='+hd_type">预览</router-link>
                            <button class="share_btn"
                                    @click="share(item)">分享给学生</button>
                            <button class="go_detail"
                                    @click="goDetail(item)">查看完成情况</button>
                        </div>
                    </div>
                </template>
                <template v-if="yw2.length">
                    <div class="list_title"><span class="title_decoration"><i></i>语文阶段性检测二<i></i></span></div>
                    <div class="unit_list">
                        <div class="list_item"
                             v-for="(item,index) in yw2"
                             :key="index">
                            <div class="unit_name ellipsis">{{item.unit_name}}</div>
                            <router-link class="preview_btn"
                                         :to="'/chinese/inspect/preview/task/'+item.paper_id+ '?hd_type=' + hd_type">预览</router-link>
                            <button class="share_btn"
                                    @click="share(item)">分享给学生</button>
                            <button class="go_detail"
                                    @click="goDetail(item)">查看完成情况</button>
                        </div>
                    </div>
                </template>
                <!-- 小学数学期末测试一 -->
                <template v-if="sx1.length">
                    <div class="list_title"><span class="title_decoration"><i></i>数学阶段性检测一<i></i></span></div>
                    <div class="unit_list">
                        <div class="list_item"
                             v-for="(item,index) in sx1"
                             :key="index">
                            <div class="unit_name ellipsis">{{item.unit_name}}</div>
                            <router-link class="preview_btn"
                                         :to="'/preview/task/21/'+item.paper_id+ '?hd_type=' + hd_type">预览</router-link>
                            <button class="share_btn"
                                    @click="share(item)">分享给学生</button>
                            <button class="go_detail"
                                    @click="goDetail(item)">查看完成情况</button>
                        </div>
                    </div>
                </template>
                <!-- 小学数学期末测试一 -->
                <template v-if="sx2.length">
                    <div class="list_title"><span class="title_decoration"><i></i>数学阶段性检测二<i></i></span></div>
                    <div class="unit_list">
                        <div class="list_item"
                             v-for="(item,index) in sx2"
                             :key="index">
                            <div class="unit_name ellipsis">{{item.unit_name}}</div>
                            <router-link class="preview_btn"
                                         :to="'/preview/task/21/'+item.paper_id+ '?hd_type=' + hd_type">预览</router-link>
                            <button class="share_btn"
                                    @click="share(item)">分享给学生</button>
                            <button class="go_detail"
                                    @click="goDetail(item)">查看完成情况</button>
                        </div>
                    </div>
                </template>
                <!-- 初中数学期末测试一 -->
                <template v-if="msx1.length">
                    <div class="list_title"><span class="title_decoration"><i></i>初中数学阶段性检测一<i></i></span></div>
                    <div class="unit_list">
                        <div class="list_item"
                             v-for="(item,index) in msx1"
                             :key="index">
                            <div class="unit_name ellipsis">{{item.unit_name}}</div>
                            <router-link class="preview_btn"
                                         :to="'/preview/task/21/'+item.paper_id+ '?hd_type=' + hd_type">预览</router-link>
                            <button class="share_btn"
                                    @click="share(item)">分享给学生</button>
                            <button class="go_detail"
                                    @click="goDetail(item)">查看完成情况</button>
                        </div>
                    </div>
                </template>
                <!-- 初中数学期末测试二 -->
                <template v-if="msx2.length">
                    <div class="list_title"><span class="title_decoration"><i></i>初中数学阶段性检测二<i></i></span></div>
                    <div class="unit_list">
                        <div class="list_item"
                             v-for="(item,index) in msx2"
                             :key="index">
                            <div class="unit_name ellipsis">{{item.unit_name}}</div>
                            <router-link class="preview_btn"
                                         :to="'/preview/task/21/'+item.paper_id+ '?hd_type=' + hd_type">预览</router-link>
                            <button class="share_btn"
                                    @click="share(item)">分享给学生</button>
                            <button class="go_detail"
                                    @click="goDetail(item)">查看完成情况</button>
                        </div>
                    </div>
                </template>
            </div>
        </template>
    </div>
</template>
<script type="text/ecmascript-6">
import loadingS from 'SRC/components/base/loadingS.vue';
export default {
    components: {
        loadingS
    },
    data () {
        return {
            hd_type: 13,//本次活动type
            inApp: localStorage.getItem("search") && Number(JSON.parse(localStorage.getItem("search")).platform),
            loading: true,
            unitData: {},
            yw1: [],//语文试卷一
            yw2: [],//语文试卷二
            sx1: [],//小学数学试卷一
            sx2: [],//小学数学试卷二
            msx1: [],//初中小学数学试卷一
            msx2: [],//初中数学试卷二
        }
    },
    created () {
        //修改页面标题
        window.document.title = "阶段性检测"
        this.$http.post(API_URL_HD_API + "/common/get_paper", {
            hd_type: this.hd_type
        }).then(res => {
            res = res.data;
            if (res.response === 'ok') {
                this.unitData = res.data
                res.data.yw_paper.forEach(e => {
                    if (e.sid == 51 && e.sequence == 1) {
                        this.yw1.push(e)
                    }
                    if (e.sid == 51 && e.sequence == 2) {
                        this.yw2.push(e)
                    }
                })
                res.data.sx_paper.forEach(e => {
                    if (e.dept_type == 1 && e.sequence == 1) {
                        this.sx1.push(e)
                    }
                    if (e.dept_type == 1 && e.sequence == 2) {
                        this.sx2.push(e)
                    }
                    if (e.dept_type == 2 && e.sequence == 1) {
                        this.msx1.push(e)
                    }
                    if (e.dept_type == 2 && e.sequence == 2) {
                        this.msx2.push(e)
                    }
                })
                if (this.yw1.length < 1 && this.yw2.length < 1 && this.sx1.length < 1 && this.sx2.length < 1 && this.msx1.length < 1 && this.msx2.length < 1) {
                    layer.alert('暂无试卷')
                }

            } else {
                layer.tips(res.message);
            }
        }).finally(() => { this.loading = false; })
    },
    methods: {
        goBack () {
            this.appFunction("ys_finish", "", 1);
        },
        share (unit) {
            let that = this
            let title = unit.school_name + (unit.sid == 21 ? "数学" : "语文") + "阶段性检测";
            let content = "点击链接参加" + (unit.sid == 21 ? "数学" : "语文") + "阶段性检测";
            if (this.inApp) {
                this.appFunction("ys_share", `${title},${content},${unit.wap_url},${String(unit.sid)[0]},${unit.unit_class_id},0,26,阶段性检测活动分享`);
            } else {
                that.$http.post(API_URL_SORT_API + '/create_sort/', {
                    url: unit.wap_url,
                    sort_type: 2
                }).then((res) => {
                    if (res.data.response === 'ok') {
                        layer.alert('在输入框中进行粘贴后，点击发送即可！', 'tea', function (index) {
                            that.copyText(`${title},${content},链接：${res.data.data.short_url}`)
                            layer.close(index)
                        }, '分享链接复制成功')
                    }
                })

            }

        },
        goDetail (u) {
            this.$store.commit('setTabtype', 1)
            this.$router.push(`/personaLearning?sid=${u.sid}&taskId=${u.paper_id}&classId=${u.unit_class_id}&hd_type=${this.hd_type}&dept_type=${u.dept_type}&className=${encodeURIComponent(u.unit_name)}`)
        },
        copyText (text) {
            const input = document.createElement('input');
            input.setAttribute('readonly', 'readonly');
            input.setAttribute('value', text);
            document.body.appendChild(input);
            input.setSelectionRange(0, 9999);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
        },
    },
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
#appIndex {
    min-height: 737px;
    background-color: #9c5e26;
    .appIndex_banner {
        height: 772px / $ppr;
        background-size: 100% 100%;
        background-image: url("./img/index-bg.jpg");
        position: relative;
        .back_icon {
            position: absolute;
            width: 64px / $ppr;
            height: 96px / $ppr;
            background-position: center;
            background-size: 18px / $ppr 34px / $ppr;
            background-repeat: no-repeat;
            background-image: url("./img/img_icon_01.png");
            cursor: pointer;
        }
    }
    .subject_list {
        padding: 0 24px / $ppr 54px / $ppr;
        position: relative;
        width: 720px / $ppr;
        box-sizing: border-box;
        .list_title {
            text-align: center;
            height: 90px / $ppr;
            line-height: 90px / $ppr;
            font-size: 32px / $ppr;
            color: #9c5e26;
            font-weight: bold;
            position: relative;
            top: 55px / $ppr;
            margin-bottom: 10px / $ppr;
            margin-top: 10px / $ppr;
            .title_decoration {
                height: 90px / $ppr;
                line-height: 80px / $ppr;
                display: inline-block;
                position: relative;
                z-index: 2;
                color: #fff;
                background: url("./img/title-bg.png") repeat;
                background-size: 10px / $ppr 90px / $ppr;
                margin: 0 -40px / $ppr;
                i {
                    display: inline-block;
                    width: 10px / $ppr;
                    height: 10px / $ppr;
                    background: #fff;
                    border-radius: 100%;
                    vertical-align: middle;
                    margin: -5px / $ppr 20px / $ppr 0;
                }
                &::before,
                &::after {
                    content: "";
                    position: absolute;
                    top: 0;
                    bottom: 0;
                    width: 40px / $ppr;
                    height: 90px / $ppr;
                }
                &::before {
                    background-size: 40px / $ppr 90px / $ppr;
                    background-image: url("./img/title-before.png");
                    left: -40px / $ppr;
                }
                &::after {
                    background-size: 40px / $ppr 90px / $ppr;
                    background-image: url("./img/title-after.png");
                    right: -40px / $ppr;
                }
            }
        }
        .unit_list {
            padding: 92px / $ppr 20px / $ppr 42px / $ppr;
            background: #fff;
            border-radius: 18px / $ppr;
            .list_item {
                display: flex;
                background-color: #fff0f0;
                border-radius: 8px / $ppr;
                height: 130px / $ppr;
                padding: 0 30px / $ppr 0 36px / $ppr;
                margin-bottom: 20px / $ppr;
                align-items: center;
                .unit_name {
                    flex-grow: 1;
                    font-size: 28px / $ppr;
                    color: #9a4400;
                    font-weight: bold;
                    overflow: hidden;
                }
                .preview_btn {
                    text-align: center;
                    font-size: 28px / $ppr;
                    color: #308fff;
                    flex-shrink: 0;
                    position: relative;
                    padding-right: 28px / $ppr;
                }
                button {
                    height: 56px / $ppr;
                    line-height: 56px / $ppr;
                    border-radius: 56px / $ppr;
                    border: none;
                    color: #fff;
                    font-size: 24px / $ppr;
                    &.share_btn {
                        width: 156px / $ppr;
                        margin-right: 16px / $ppr;
                        background-color: #99d024;
                        background: -webkit-linear-gradient(
                            left,
                            #99d024 0%,
                            #8bca4c 100%
                        );
                    }
                    &.go_detail {
                        width: 190px / $ppr;
                        color: #9a4400;
                        background-color: #ffd666;
                        background: -webkit-linear-gradient(
                            left,
                            #ffd666 0%,
                            #f8c21f 100%
                        );
                    }
                }
            }
        }
    }
}
</style>